import { FC } from 'react';
import { Button } from '@vadiun/react-components';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { Alarm, Schedule } from '@material-ui/icons';
import * as Yup from 'yup';
import { ChoferTrabajandoExtendedPayload } from '../models/ChoferTrabajando';

interface ExtendExcessModalProps {
  driver: { id: number; name: string, code: number | undefined; };
  onSubmit: (payload: ChoferTrabajandoExtendedPayload) => Promise<void>;
  onCancel: () => void;
  closeShift?: (id: number) => void;
}

const validationSchema = Yup.object().shape({
  amount: Yup.number()
    .required('Campo requerido')
    .integer('Debe ser un número entero')
    .min(1, 'Debe ser mayor a 0')
    .typeError('Debe ser un número válido')
});

const ExtendExcessModal: FC<ExtendExcessModalProps> = ({
  driver,
  onSubmit,
  onCancel,
  closeShift
}) => {
  const initialValues = {
    amount: 0
  };

  const handleSubmit = async (
    values: { amount: number },
    { setSubmitting }: any
  ) => {
    try {
      const payload: ChoferTrabajandoExtendedPayload = {
        minutes: values.amount
      };
      await onSubmit(payload);
    } catch (error) {
      console.error('Error al actualizar el exceso:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col p-4">
      <div className="flex flex-col items-center mb-6">
        <div className="relative">
          <Schedule
            style={{
              fontSize: 80,
              color: '#f59e0b', 
              marginBottom: '1rem'
            }}
          />
          <Alarm
            style={{
              fontSize: 40,
              color: '#ef4444',
              position: 'absolute',
              right: -10,
              top: -10
            }}
          />
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-800">
          Extensión de Jornada
        </h2>
        <p className="text-lg text-center text-gray-600 mt-2">
          Chofer: <span className="font-semibold">#${driver.code} - {driver.name}</span>
        </p>
      </div>
      <h2 className="flex justify-center text-lg  mb-4 border-t-2 border-blue-300 pt-4">
        - Ingrese los minutos a extender -
      </h2>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form className="flex w-full flex-col gap-4 items-center">
            <div className="flex text-center ">
              <Field
                component={TextField}
                name="amount"
                label="Minutos"
                type="number"
                variant="outlined"
                fullWidth
                margin="normal"
                style={{ width: '140px' }}
                inputProps={{ min: 1, step: 1 }}
              />
            </div>
            <div className="flex w-full justify-between gap-4 mt-4">
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                Cancelar
              </Button>
              {closeShift && (
                <Button
                  disabled={isSubmitting}
                  variant="light"
                  color="red"
                  onClick={() => closeShift(driver.id)}
                  className="whitespace-nowrap"
                >
                  Terminar jornada
                </Button>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!isValid || !dirty || isSubmitting}
              >
                Confirmar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ExtendExcessModal;
